export const ASC = 'ASC' as const;
export const DESC = 'DESC' as const;

export type OrderDirection = typeof ASC | typeof DESC;

export const ORDER_DIRECTION = {
	[ASC]: ASC,
	[DESC]: DESC,
} as const;
